import { QuickVideoSortKeys } from 'lib/api/quickVideo/types';

export const getQuickVideoTableFields = (t: Function) => [
  {
    value: 'name',
    label: t('Name'),
    sortable: true,
    sortKey: QuickVideoSortKeys.NAME,
  },
  {
    value: 'category',
    label: t('Category'),
    sortable: true,
    sortKey: QuickVideoSortKeys.CATEGORY,
  },
  {
    value: 'test',
    label: t('Test'),
    sortable: false,
    sortKey: null,
  },
  {
    value: 'enable',
    label: t('Enable'),
    sortable: false,
    sortKey: null,
  },
  {
    value: 'actions',
    label: t('Actions'),
    sortable: false,
    sortKey: null,
  },
];
